<template>
    <div>
        <!-- user-setting start -->
        <div class="user-setting-details mg-top-90">
            <div class="container">
                <div class="ba-navbar-user text-center">
                    <div class="thumb">
                        <!-- <img :src="user.avatarb64" :alt="user.name" height="77px"> -->
                        <i class="fa fa-user-circle text-primary fa-5x"></i>
                    </div>
                    <div class="details">
                        <h5> {{ user.firstname +' '+ user.lastname}} - {{ user.company }}</h5>
                        <!-- <p>ID: {{ user.id }}</p> -->
                    </div>
                </div>
            </div>
        </div>
        <!-- user-setting End -->

        <!-- navbar end -->
        <div class="allpage-area">
            <div class="container">

                <div class="ba-all-page-inner style-no-arrow mb-4">
                    <h5>Profile</h5>
                    <ul>
                        <li><a><i class="las la-envelope pe-2"></i>{{ user.email }}</a></li>
                        <li><a><i class="las la-user pe-2"></i>{{ user.firstname }} {{ user.lastname }}</a></li>
                        <!-- <li><a><i class="las la-user pe-2"></i>{{ user.lastname }}</a></li> -->
                        <li><a><i class="las la-building pe-2"></i>{{ user.company }}</a></li>
                        <li><a href="#" @click="changepassword = !changepassword"><i class="las la-lock pe-2"></i>Change
                                Password</a></li>
                    </ul>
                </div>

                <div v-show="changepassword" class="highlight-container mb-3 px-4">
                    <div class="modal-content">
                        <div class="row gx-5">
                            <div class="col">
                                <div class="menu-close">
                                    <i @click="changepassword = false"
                                        class="la la-times text-success float-right hover-cursor"></i>
                                </div>
                            </div>
                        </div>
                        <div class="modal-header">
                            <h5 class="modal-title">Password Settings</h5>
                        </div>
                        <div class="modal-body mt-3">
                            <div class="action-sheet-content">
                                <div class="form-group basic">
                                    <label class="label">Old Password</label>
                                    <div class="input-group mb-3">
                                        <input type="password" class="form-control form-control-lg" id="password_old"
                                            v-model="password_old" :state="password_old_valid"
                                            placeholder="<type old passsword>" @keyup.native="isChanged()"
                                            autocomplete="old-password">
                                        <div class="input-group-append">
                                            <b-button size="sm" variant="outline-secondary" :disabled="!password_old"
                                                @click="password_old = ''">
                                                <i class="la la-times"></i>
                                            </b-button>
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group basic">
                                    <label class="label">New Password</label>
                                    <div class="input-group mb-3">
                                        <input type="password" class="form-control form-control-lg" id="password_new1"
                                            v-model="password_new1" :state="password_new1_valid"
                                            placeholder="<type new passsword>" @keyup.native="isChanged()"
                                            autocomplete="new-password">
                                        <div class="input-group-append">
                                            <b-button size="sm" variant="outline-secondary" :disabled="!password_new1"
                                                @click="password_new1 = ''">
                                                <i class="la la-times"></i>
                                            </b-button>
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group basic">
                                    <label class="label">Retype New Password</label>
                                    <div class="input-group mb-3">
                                        <input type="password" class="form-control form-control-lg" id="password_new2"
                                            v-model="password_new2" :state="password_new2_valid"
                                            placeholder="<retype new passsword>" @keyup.native="isChanged()"
                                            autocomplete="new-password">
                                        <div class="input-group-append">
                                            <b-button size="sm" variant="outline-secondary" :disabled="!password_new2"
                                                @click="password_new2 = ''">
                                                <i class="la la-times"></i>
                                            </b-button>
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group basic">
                                    <button type="button" class="btn-c btn-blue w-100 btn-lg" data-dismiss="modal"
                                        @click="save_password()">Save It</button>
                                </div>

                            </div>
                        </div>
                    </div>


                </div>



                <div class="ba-all-page-inner style-no-arrow style-two settings_codes">
                    <h5>Account</h5>
                    <ul>
                        <li><a><i class="las la-bars pe-2"></i>A/C's <span class="bg-btn text-secondary"
                                    v-for="(ac, index) in user.slac.split(',')" :key="index">{{ ac }}</span></a></li>

                        <li><a href="#" @click="showyourref = !showyourref"><i class="las la-bars pe-2"></i>Your Ref / PO <span v-if="user.yourref"><span class="bg-btn text-secondary"
                            v-for="(yr, index) in user.yourref.split(',')" :key="index">{{ yr }}</span></span></a></li>

                    </ul>

                </div>

                <div v-show="showyourref" class="highlight-container mt-2 mb-3 px-4">
                    <div class="modal-content">
                        <div class="row gx-5">
                            <div class="col">
                                <div class="menu-close">
                                    <i @click="showyourref = false"
                                        class="la la-times text-success float-right hover-cursor"></i>
                                </div>
                            </div>
                        </div>
                        <div class="modal-header">
                            <h5 class="modal-title">Your Ref / PO Settings</h5>
                        </div>
                        <div class="modal-body mt-3">
                            <div class="action-sheet-content">
                             
                                <div class="form-group basic">
                                    <label class="label">Your Ref P/O</label>
                                    <div class="input-group mb-3">
                                        <input type="yourref" class="form-control form-control-lg" id="yourref"
                                            v-model="user.yourref" 
                                            placeholder="<Your Ref P/O>" @keyup.native="isChanged()">
                                        <div class="input-group-append">
                                            <b-button size="sm" variant="outline-secondary" :disabled="!yourref"
                                                @click="yourref = ''">
                                                <i class="la la-times"></i>
                                            </b-button>
                                        </div>
                                    </div>
                                </div>

                                <!-- <div class="form-group basic">
                                    <button type="button" class="btn-c btn-blue w-100 btn-lg" data-dismiss="modal"
                                        @click="save_yourref()">Save It</button>
                                </div> -->

                            </div>
                        </div>
                    </div>


                </div>


                <div class="ba-all-page-inner style-no-arrow mb-4">
                    <ul>
                        <li><a href="#" @click="$router.push('/logout')"><i class="fa fa-sign-out pe-2"></i> Sign
                                Out</a></li>
                    </ul>
                </div>


            </div>
        </div>
        <!-- navbar end -->
    </div>

</template>
<script>

export default {
    name: "Settings",
    data() {
        return {
            changepassword: false,
            showyourref:false
        }
    },
    computed: {
        yourref() {

        }
    }
}
</script>